import React from "react";
import { useController, Control } from "react-hook-form";

import { Input as ShadInput } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type InputProps = {
  name: string;
  control: Control<any>;
  type?: string;
  label: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
};

export default function Input({
  className,
  name,
  control,
  type,
  label,
  placeholder,
  disabled,
  ...rest
}: InputProps) {
  const {
    field: { onChange, value, ref },
  } = useController({
    name,
    control,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={cn("grid gap-2", className)}>
      <p className="text-sm font-medium">{label}</p>
      <ShadInput
        id={name}
        name={name}
        ref={ref}
        value={value}
        onChange={handleChange}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        {...rest}
      />
    </div>
  );
}
